import React, { Component } from 'react';
import { NumberOfResults } from 'app/area/codetable/list/search';
import { SpinLoader } from 'app/components';
import { CustomCodetableListComponentProps } from 'app/area/codetable/list/list-renderer/types';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { addLinkFactory } from 'app/area/codetable/list/list-renderer/common/add-link-factory';
import { UomCodetableListItems } from 'app/area/codetable/list/list-renderer/screens/uom/uom-codetable-list-items';
import { MergeCodeContainer } from 'app/area/codetable/common/merge-code/merge-code-container';
import styles from './uom-codetable-list-component.scss';

export class UomCodetableListComponent extends Component<CustomCodetableListComponentProps> {

  public render() {
    const { isHierarchy, isHierarchyMode, shouldRenderSpinLoader,
      breadcrumbs, codetableId, codeId, codeListBranch, rootBranch,
      codeListBranchState, loadFromParent, reloadCodeItems, expandCodeItem, deleteCodeItem,
      loadCodesAccess, clearCodesAccess, itemAccess, fetchingItemAccess,
      metadata, mergeCode, updateMergeCode, options, loadOptions, validation, resetValidation,
      translation, screenPayload } = this.props;

    const shouldRenderList = !!codeListBranch && codeListBranch.length > 0 && rootBranch
      && rootBranch.numberOfResults > 0;

    return <SearchFilters {...this.props}>
      <div className={`${styles.codetableListContainer} ${styles.codetableListCenter}`}>
        <div className={styles.codetableListHolder}>
          <div className={styles.numberOfResults}>
            <NumberOfResults
              rootBranch={rootBranch}
              translation={translation} />
          </div>

          {shouldRenderSpinLoader ? <SpinLoader /> : undefined}
          {
            shouldRenderList && <div className={`${styles.listItemsContainer} ${isHierarchyMode ? styles.hierarchyResults : ''}`}>
              <div className={styles.listItems}>
                <UomCodetableListItems
                  screenPayload={screenPayload}
                  breadcrumbs={breadcrumbs}
                  treeDepthLevel={0}
                  hierarchyMetadata={[]}
                  isZebra={undefined}
                  codetableId={codetableId}
                  codeId={codeId}
                  isHierarchyMode={isHierarchyMode}
                  isHierarchy={isHierarchy}
                  codeAccessConfiguration={this.props.codeAccessConfiguration}
                  codeListBranchState={codeListBranchState}
                  codeListBranch={codeListBranch}
                  loadFromParent={loadFromParent}
                  reloadCodeItems={reloadCodeItems}
                  expandCodeItem={expandCodeItem}
                  deleteCodeItem={deleteCodeItem}
                  itemAccess={itemAccess}
                  fetchingItemAccess={fetchingItemAccess}
                  loadCodesAccess={loadCodesAccess}
                  clearCodesAccess={clearCodesAccess}
                  parentId={undefined}
                  translation={translation}
                  addLinkFactory={addLinkFactory}
                  validation={validation}
                  resetValidation={resetValidation}
                  metadata={metadata}
                  mergeCode={mergeCode}
                  updateMergeCode={updateMergeCode}
                  options={options}
                  loadOptions={loadOptions} />
              </div>
            </div>
          }
        </div>
      </div>
      <MergeCodeContainer {...this.props} />
    </SearchFilters>;
  }
}
